import React, { createContext, useContext, useEffect, useState } from 'react';


const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {},
});


export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Lecture depuis localStorage au montage
    return localStorage.getItem('cinef-theme') || 'dark';
  });

  useEffect(() => {
    
    localStorage.setItem('cinef-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};


export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;